import { Component, Input, OnInit, Output, EventEmitter, NgZone } from "@angular/core";
import "./veriPills.component.scss";

export interface IVeriNavPill<T = any> {
    title: string;
    count?: number;
    data?: T;
    selected?: boolean;
}

@Component({
    selector: "veri-nav-pills",
    template: require("./veriPills.component.html"),
})
export class VeriNavPillsComponent implements OnInit {

    @Input() navPills: IVeriNavPill[];
    @Output() onSelected: EventEmitter<IVeriNavPill> = new EventEmitter();

    constructor() {
    }

    ngOnInit(): void { }

    navPillClicked(navPill: IVeriNavPill) {
        this.navPills.forEach(pill => pill.selected = false);
        navPill.selected = true;

        this.onSelected.emit(navPill);
    }
}
